exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.notched.circle.loading.icon{\n  background-color: transparent;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/contact/new-contact/new-contact.component.css
// module id = ../../../../../src/app/_components/contact/new-contact/new-contact.component.css
// module chunks = main